import { useQuery } from "react-query";

import { AuditService } from "../services/audit.service";
import { CellService } from "../services/cell.service";
import ClientService from "../services/client.service";
import UserService from "../services/user.service";
import { queryKeys } from "./keys";

const AUDIT_STALE_TIME_MS = 10 * 60 * 1000;

export function useProfile() {
  return useQuery(queryKeys.profile, () => UserService.getMyProfile());
}

export function useAllUsers() {
  return useQuery(queryKeys.usersAll, () => UserService.allUsers());
}

export function useAllCells() {
  return useQuery(queryKeys.cellsAll, () => CellService.allCells());
}

export function useClients(params?: Record<string, unknown>) {
  return useQuery(queryKeys.clients(params), () =>
    ClientService.getClients(params)
  );
}

export function useProjectLastEditorAudit(
  projectId: string | null | undefined,
  enabled: boolean
) {
  return useQuery(
    queryKeys.projectLastEditorAudit(projectId ?? ""),
    () => AuditService.getProjectLastEditor(projectId!),
    {
      enabled: !!projectId && enabled,
      staleTime: AUDIT_STALE_TIME_MS,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
}

export function useProjectTimelineAudit(
  projectId: string | null | undefined,
  createdAt: string | undefined
) {
  return useQuery(
    queryKeys.projectTimelineAudit(projectId ?? ""),
    () =>
      AuditService.getByProjectAndArea({
        project: projectId!,
        area: "project",
      }),
    {
      enabled: !!projectId && !!createdAt,
      staleTime: AUDIT_STALE_TIME_MS,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
    }
  );
}
